import { Services } from '../services';

export function startHandlingContextMenuClicked(services: Services): void {
  chrome.contextMenus.onClicked.addListener(function(info, tab) {
    services.contextMenuService.handleContextMenuClicked(info, tab);
  });
}
